var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogosJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 85,
    viewBox: "0 0 86 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.863281 0H85.8633V85H0.863281V0Z",
    fill: "#F7DF1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2127 71.0321L29.7172 67.0955C30.9723 69.3204 32.1138 71.2031 34.8521 71.2031C37.4768 71.2031 39.132 70.1764 39.132 66.1827V39.0233H47.1196V66.2956C47.1196 74.5689 42.27 78.3348 35.1944 78.3348C28.8045 78.3348 25.0954 75.0254 23.2124 71.0314M51.4583 70.1761L57.9621 66.4105C59.6744 69.2066 61.8997 71.2605 65.8363 71.2605C69.1463 71.2605 71.2567 69.6057 71.2567 67.3233C71.2567 64.5847 69.0885 63.6145 65.4368 62.0174L63.4403 61.1608C57.6772 58.7081 53.8546 55.6268 53.8546 49.1223C53.8546 43.1311 58.419 38.5664 65.5514 38.5664C70.6295 38.5664 74.2811 40.3354 76.9055 44.957L70.6859 48.9513C69.3163 46.4979 67.8334 45.5281 65.551 45.5281C63.2115 45.5281 61.728 47.0116 61.728 48.9513C61.728 51.3476 63.2115 52.3181 66.6348 53.8016L68.6316 54.6573C75.4217 57.5675 79.2443 60.5342 79.2443 67.2094C79.2443 74.3992 73.5958 78.3358 66.0072 78.3358C58.59 78.3358 53.7971 74.7983 51.458 70.1764",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_29"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 85,
    fill: "white",
    transform: "translate(0.863281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosJavascript);
export default __webpack_public_path__ + "static/media/logos_javascript.b4f988eede5c37e6856655fcd6e5ef3f.svg";
export { ForwardRef as ReactComponent };